module.exports = __webpack_public_path__ + "img/04.cb5c1460.png";